import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import EmployeeDetailControl from '../Employee/EmployeeDetailControl.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const TrainingAndAccomodation = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;


	const { search } = useLocation();
		const searchparams = new URLSearchParams(search);
		const param = searchparams.get("id");


	// alert(param);

const [precheckup, setPreCheckup] = useState({
    entry_venue:"",
    room_no: "",
	rm_entry_date: "",
	rm_exit_date: "",
	train_date:"",
	train_by:"",
	train_venue:"",
	next_com_date:"",
	unif_issuedate:"",
	unif_sets:"",
	uniform_remark:"",
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setPreCheckup({ ...precheckup, [name]: value });

		
	}


	const [allemployeeval, setallemployeeval]= useState([]);

	const handleAllEmployee = async () => {

		axios.get(API_BASE_URL +'/showallemployee/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		// .then(res1 => console.log(res1.data.user_det))
		.then(res1 => setallemployeeval(res1.data.user_det))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllEmployee();
	  }, []);



	  const [data, setData] = useState([]);

	  useEffect(() => {
		axios.get(API_BASE_URL + '/fetchprecheck/'+ param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])



	// useEffect(() => {
	// 	axios.get(API_BASE_URL + '/showprecheck/'+ param, {
	// 		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	// 	})


	// 		 .then(res => setPreCheckup(res.data[0]))
	// 		// .then(res => console.log(res.data[0]))
	// 		.catch(err => console.log(err));
	// }, [])



	const handleUpdateTrainingAccomodationSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		//alert(param);


		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addtrainingaccomodation', { entry_venue: precheckup.entry_venue,room_no:precheckup.room_no,rm_entry_date:precheckup.rm_entry_date,rm_exit_date:precheckup.rm_exit_date,train_date:precheckup.train_date,train_by:precheckup.train_by,train_venue:precheckup.train_venue,next_com_date:precheckup.next_com_date,unif_issuedate:precheckup.unif_issuedate,unif_sets:precheckup.unif_sets,uniform_remark:precheckup.uniform_remark,user_id:param }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	

	


	return (
		<>


<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>


					<div className="section-body mt-3" style={{
                
                backgroundColor:
                    "#fff",
            }}>
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title" style={{color:'#e96827',fontSize:'12px',fontWeight:'600'}}>Accommodation Info</h3>
										</div>
										<div className="card-body">
                                        <form onSubmit={handleUpdateTrainingAccomodationSubmit}> 
												<div class="row">


                                   <div className="col-md-6 col-sm-12">
									<label className="form-label">Entry Venue</label>
										<div className="form-group">

										<input type="text" className="form-control required-input required-tooltip" name="entry_venue" value={precheckup.entry_venue}
																onChange={handelInput} placeholder="Entry Venue" />
										</div>
									</div>


                                    <div className="col-md-6 col-sm-12">
									<label className="form-label">Room / Ward No</label>
										<div className="form-group">

										<input type="text" className="form-control required-input required-tooltip" name="room_no" value={precheckup.room_no}
																onChange={handelInput} placeholder="Room / Ward No" />
										</div>
									</div>
										
									<div className="col-md-6 col-sm-12">
									<label className="form-label">Entry Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="rm_entry_date" value={precheckup.rm_entry_date}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                    <div className="col-md-6 col-sm-12">
									<label className="form-label">Exit Date</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="rm_exit_date" value={precheckup.rm_exit_date}
																onChange={handelInput} placeholder="" />
										</div>
									</div>

										</div>


										<div className="card-header">
											<h3 className="card-title" style={{color:'#e96827',fontSize:'12px',fontWeight:'600'}}>Training Info</h3>
										</div>
										<div className="card-body">
                                        
												<div class="row">
										
								<div className="col-md-6 col-sm-12">
									
									<div className="form-group">
									<label className="form-label">Training Date</label>
										

										<input type="date" className="form-control required-input required-tooltip" name="train_date" value={precheckup.train_date}
																onChange={handelInput} placeholder="" />
										</div>
									
								</div>


									<div className="col-md-6 col-sm-12">
											<div className="form-group">
											<label className="form-label">Trainer Name </label>

											<select className="form-control show-tick required-input required-tooltip" name="train_by" value={precheckup.train_by} onChange={handelInput}>
											<option value="">None</option>
												{allemployeeval.map(option1 => (
												<option key={option1.user_id} value={option1.user_id}>
												{option1.first_name} {option1.last_name} {option1.employee_id}
												</option>
												))}
										</select>
										</div>
									</div>


									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">Entry Venue</label>
										<div className="form-group">

										<input type="text" className="form-control required-input required-tooltip" name="train_venue" value={precheckup.train_venue}
																onChange={handelInput} placeholder="Venue" />
										</div>
									</div>

                                    


									<div className="col-md-6 col-sm-12 required-tooltip">
										<label className="form-label">Next Commission Date</label>
										<div className="form-group">
										<input type="date" className="form-control required-input required-tooltip" name="next_com_date" value={precheckup.next_com_date}
																onChange={handelInput} placeholder="" />
										</div>
									</div>
									</div>

									

										</div>




										<div className="card-header">
											<h5 className="card-title" style={{color:'#e96827',fontSize:'12px',fontWeight:'600'}}> Uniform Issued </h5>
										</div>
										<div className="card-body">
                                       
												<div class="row">
										
									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">Date Of Issue</label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="unif_issuedate" value={precheckup.unif_issuedate}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">No of Sets</label>
										<div className="form-group">

										<input type="text" className="form-control required-input required-tooltip" name="unif_sets" value={precheckup.unif_sets}
																onChange={handelInput} placeholder="" />
										</div>
									</div>


                                  

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Remarks</label>

										<textarea
										id="textarea"
										name="uniform_remark"
										value={precheckup.uniform_remark} // Bind the value to state
										onChange={handelInput} // Update state on change
										placeholder="Remarks"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										

									
										</div>




										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>


										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Issued Date</th>
															<th>No of set</th>
															<th>Remarks</th>
														</tr>
													</thead>
													<tbody>



														{
															data.map((emp, index) => {

																return <tr key={index}>
																	
																	<td>
																		<span>{emp.unif_issuedate}</span>
																	</td>
																	<td>
																		<span>{emp.unif_sets}</span>
																	</td>
																	
																	<td>
																		<span>{emp.uniform_remark}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(TrainingAndAccomodation);